import { useNavigate, useParams } from 'react-router-dom'
import TabBar from '@/components/shared/TabBar'
import AppsDashboard from '@/components/apps/AppsDashboard'
import AppsCatalogo from '@/components/apps/AppsCatalogo'
import AppsActivaciones from '@/components/apps/AppsActivaciones'
import AppsPlanes from '@/components/apps/AppsPlanes'
import { IconBarChart, IconPackage, IconUsers, IconCreditCard } from '@/components/icons/Icons'
import { PageHeader } from '@/components/ui'

/* Pestañas del módulo Apps. Dashboard es el aterrizaje (/apps).
   Hueco reservado para futuras: Facturación, Tarifario. */
const TABS = [
  { key: 'dashboard', label: 'Dashboard', icon: <IconBarChart size={15} /> },
  { key: 'catalogo', label: 'Catálogo', icon: <IconPackage size={15} /> },
  { key: 'activaciones', label: 'Activaciones', icon: <IconUsers size={15} /> },
  { key: 'planes', label: 'Planes', icon: <IconCreditCard size={15} /> },
  // { key: 'tarifario', label: 'Tarifario' },
]

const VALID_TABS = new Set(['catalogo', 'activaciones', 'planes'])

export default function Apps() {
  const { tab } = useParams()
  const navigate = useNavigate()
  const active = tab && VALID_TABS.has(tab) ? tab : 'dashboard'

  const onTabChange = (key: string) => navigate(key === 'dashboard' ? '/apps' : `/apps/${key}`)

  return (
    <div className="page-enter">
      <PageHeader breadcrumbs={[{ label: 'Apps' }]} />

      <TabBar tabs={TABS} activeTab={active} onTabChange={onTabChange} />

      <div style={{ marginTop: 20 }}>
        {active === 'catalogo' ? <AppsCatalogo /> : active === 'activaciones' ? <AppsActivaciones /> : active === 'planes' ? <AppsPlanes /> : <AppsDashboard />}
      </div>
    </div>
  )
}
